import React from "react";
import { FaFacebookF, FaInstagram } from "react-icons/fa"; // Importing react-icons

const FooterTest = () => {
  return (
    <footer className="bg-dark">
      <div className="max-w-screen-xl px-4 py-8 mx-auto space-y-8 sm:px-6 lg:px-8">
        {/* Social Media Icons */}
        <div className="flex justify-center space-x-6">
          {[
            {
              name: "Facebook",
              href: "#",
              icon: (
                <FaFacebookF className="w-6 h-6 text-white hover:fill-[#f7b22d] transition duration-300" />
              ),
            },
            {
              name: "Instagram",
              href: "#",
              icon: (
                <FaInstagram className="w-6 h-6 text-white hover:fill-[#f7b22d] transition duration-300" />
              ),
            },
          ].map((icon) => (
            <a
              key={icon.name}
              href={icon.href}
              className="flex items-center justify-center"
            >
              <span className="sr-only">{icon.name}</span>
              {icon.icon}
            </a>
          ))}
        </div>

        {/* Copyright */}
        <p className="mt-8 text-base leading-6 text-center text-white">
          © 2025 The Hive. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default FooterTest;
